import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  VideoContentsActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/video-content'
import videoApi from '@api/video-content'
import {ReduxAction} from "@actions/index";
import {RequestData} from '@models/axios';


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(videoApi.getList, payload);
    yield put(fetchSuccess(res));
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(videoApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}

/**
 * This function will handle add and delete categories form a vidoe
 * @param params
 * @param payload
 */
function* updateVideoCategories({params, payload}: RequestData) {
  try {
    const {new_categories, deleted_categories} = payload;
    if (new_categories.length > 0) {
      yield call(videoApi.addCategories, {
        params,
        payload: {
          category_ids: new_categories
        }
      });
    }
    if (deleted_categories.length > 0) {
      yield call(videoApi.deleteCategories, {
        params,
        payload: {
          category_ids: deleted_categories
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}


/**
 * This function handles add and delete tags from a video
 * @param params
 * @param payload
 */
function* updateVideoTags({params, payload}: RequestData) {
  try {
    const {new_tags, deleted_tags} = payload;
    if (new_tags.length > 0) {
      yield call(videoApi.addTags, {
        params,
        payload: {
          tag_ids: new_tags
        }
      });
    }
    
    if (deleted_tags.length > 0) {
      yield call(videoApi.deleteTags, {
        params,
        payload: {
          tag_ids: deleted_tags
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}


/**
 * This function handles add and delete person-roles from a video
 * @param params
 * @param payload
 */
function* updateVideoPersonRoles({params, payload}: RequestData) {
  try {
    const {new_person_roles, deleted_person_roles} = payload;
    if (new_person_roles.length > 0) {
      yield call(videoApi.addPersonRoles, {
        params,
        payload: {
          person_with_role_list: new_person_roles
        }
      });
    }
    if (deleted_person_roles.length > 0) {
      yield call(videoApi.deletePersonRoles, {
        params,
        payload: {
          ids: deleted_person_roles
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}


/**
 * This function will replace ContentListStrategy of a special video with type: video_content_list
 * @param params
 * @param payload
 */
function* updateContentListStrategy({params, payload}: RequestData) {
  try {
    yield call(videoApi.updateContentListStrategy, {
      params,
      payload
    });
  } catch (e) {
    console.log(e)
  }
}


/**
 * This function handles add and delete content Table items of video with type: video_content_list
 * @param params
 * @param payload
 */
function* updateVideoContentListItems({params, payload}: RequestData) {
  try {
    const {new_videos, deleted_videos} = payload;
    if (new_videos.length > 0) {
      yield call(videoApi.addContentListItems, {
        params,
        payload: {
          ids: new_videos
        }
      });
    }
    
    if (deleted_videos.length > 0) {
      yield call(videoApi.deleteContentListItems, {
        params,
        payload: {
          ids: deleted_videos
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}



/**
* Check if there is gallery id for put or not for post
 * anyway put should be call, because of reordering items
* @param params
* @param payload
*/
function* updateGallery({params, payload}: RequestData) {
  const {selectedItems, deletedItems} = payload;
  const newItems = selectedItems.filter(item => !item.id);
  const editedItems = selectedItems.filter(item => item.id);
  try {
    if (deletedItems.length > 0) {
      yield call(videoApi.deleteGallery, {
        params,
        payload: {
          items: deletedItems
        }
      });
    }
    if (editedItems && editedItems.length > 0) {
      yield call(videoApi.updateGallery, {
        params,
        payload: {
          items: editedItems
        }
      });
    }
    if (newItems && newItems.length > 0) {
      yield call(videoApi.createGallery, {
        params,
        payload: {
          items: newItems
        }
      });
    }
    
  } catch (e) {
    console.log(e)
  }
}


/**
* Check if there is gallery id for put or not for post
 * anyway put should be call, because of reordering items
* @param params
* @param payload
*/
function* updateFiles({params, payload}: RequestData) {
  const {selectedItems, deletedItems} = payload;
  const newItems = selectedItems.filter(item => !item.id);
  const editedItems = selectedItems.filter(item => item.id && item.updated);
  try {
    if (deletedItems.length > 0) {
      yield call(videoApi.deleteFiles, {
        params,
        payload: {
          ids: deletedItems
        }
      });
    }
    if (editedItems && editedItems.length > 0) {
      yield call(videoApi.updateVideoFiles, {
        params,
        payload: {
          video_content_files: editedItems
        }
      });
    }
    if (newItems && newItems.length > 0) {
      yield call(videoApi.addFiles, {
        params,
        payload: {
          video_content_files: newItems
        }
      });
    }
    
  } catch (e) {
    console.log(e)
  }
}


/**
 * This function is called after a video is created and updated successfully and will update all video's related entities
 * @param category_id
 * @param payload
 */
function* updateVideorelatedEntities(video_id: string, payload) {
  try {
    const params = {id: video_id};
    const {tags, categories, personRole, content_list_strategy, content_list_items, gallery, files} = payload;
    
    if (categories) {
      yield updateVideoCategories({
        params,
        payload: categories
      });
    }
    
    if (tags) {
      yield updateVideoTags({
        params,
        payload: tags
      });
    }
    
    if (personRole) {
      yield updateVideoPersonRoles({
        params,
        payload: personRole
      });
    }
    
    if (content_list_strategy) {
      yield updateContentListStrategy({
        params,
        payload: content_list_strategy
      });
    }
    
    if (content_list_items) {
      yield updateVideoContentListItems({
        params,
        payload: content_list_items
      });
    }
    
    if(gallery){
      yield updateGallery({
        params,
        payload : gallery
      });
    }
    
    if(files){
      yield updateFiles({
        params,
        payload : files
      });
    }
    
  } catch (e) {
    console.log(e)
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {videoContent} = payload.payload;
    const response = yield call(videoApi.create, {
      payload: videoContent
    });
    
    const video = response.data;
    yield updateVideorelatedEntities(video.id, payload.payload);
    yield put(createSuccess(video));
    payload.onSuccessCallback && payload.onSuccessCallback(video);
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {videoContent} = payload.payload;
    const response = yield call(videoApi.update, {
      ...payload,
      payload: videoContent
    });
    
    const category = response.data;
    yield updateVideorelatedEntities(category.id, payload.payload);
    yield put(updateSuccess(category));
    payload.onSuccessCallback && payload.onSuccessCallback();
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(videoApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* videoContentsSaga() {
  yield all([
    yield takeEvery(VideoContentsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(VideoContentsActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(VideoContentsActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(VideoContentsActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(VideoContentsActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  ])
}

export default videoContentsSaga
